import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage } from 'firebase/messaging';
import { isMobile } from 'react-device-detect';

// Firebase configuration
const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
	measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Messaging is only needed if not on mobile
export const messaging = !isMobile ? getMessaging(firebaseApp) : null;

// Function to get or register the service worker
export const getOrRegisterServiceWorker = async () => {
	if (isMobile) return;
	if ('serviceWorker' in navigator) {
		return navigator.serviceWorker
			.getRegistration('/firebase-push-notification-scope')
			.then((serviceWorker) => {
				if (serviceWorker) return serviceWorker;
				return navigator.serviceWorker.register('../jobstas-qa/firebase-messaging-sw.js', {
					scope: '/jobstas-qa/firebase-push-notification-scope',
				});
			});
	}
	throw new Error('The browser doesn’t support service workers.');
};

// Function to get Firebase token
export const getFirebaseToken = async () => {
	if (isMobile) return null;
	const serviceWorkerRegistration = await getOrRegisterServiceWorker();
	return getToken(messaging, {
		vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
		serviceWorkerRegistration,
	});
};

// Function to handle foreground messages
export const onForegroundMessage = () => {
	if (isMobile) return Promise.resolve(null);
	return new Promise((resolve) => onMessage(messaging, (payload) => resolve(payload)));
};

// Listener for Firebase messages
export const onMessageListener = () => {
	if (isMobile) return Promise.resolve(null);
	return new Promise((resolve) => onMessage(messaging, (payload) => resolve(payload)));
};

// Function to request notification permissions
export const requestPermission = async () => {
	if (isMobile) return;
	try {
		const permission = await Notification.requestPermission();
		if (permission === 'granted') {
			const token = await getFirebaseToken();
			if (token) localStorage.setItem('fcmToken', token);
		} else {
			console.error('Notification permission denied.');
		}
	} catch (error) {
		console.error('An error occurred while retrieving token.', error);
	}
};

export default firebaseApp;
